<template>
    <div>
        <el-card class="form-container" shadow="never" style="margin-top: 5px">
            <el-form :inline="true" size="small" label-width="140px">
                <el-col :span="8">
                    <span>选择日期：</span>
                    <el-date-picker
                        v-model="queryOrderData.createDt"
                        type="daterange"
                        :clearable="true"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-col>
                <el-form-item label="选择分组">
                    <el-select v-model="queryOrderData.ab" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="a" value="a"></el-option>
                        <el-option label="b" value="b"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择端">
                    <el-select v-model="queryOrderData.sys" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="安卓国内" value="安卓国内"></el-option>
                        <el-option label="苹果国内" value="苹果国内"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" class="sub-sub11">
                    <el-button type="primary" @click="searchOrder">开始查询</el-button>
<!--                    <el-button type="primary" @click="exportExcel">导出</el-button>-->
                </el-form-item>
            </el-form>
            <el-table border="" :data="orderList">
                <el-table-column label="日期" prop="dt" align="center"></el-table-column>
                <el-table-column label="端" prop="sys" align="center"></el-table-column>
                <el-table-column label="组" prop="ab" align="center"></el-table-column>
                <el-table-column label="58元" prop="m58" align="center"></el-table-column>
                <el-table-column label="38元" prop="m38" align="center"></el-table-column>
                <el-table-column label="48元" prop="m48" align="center"></el-table-column>
                <el-table-column label="18元" prop="m18" align="center"></el-table-column>
                <el-table-column label="总销售额" prop="money" align="center"></el-table-column>
                <el-table-column label="总活跃人次" prop="active" align="center"></el-table-column>
                <el-table-column label="ARPU" prop="arpu" align="center"></el-table-column>

            </el-table>
<!--            <el-pagination-->
<!--                style="margin-top: 5px"-->
<!--                @size-change="handleSizeChange"-->
<!--                @current-change="handleCurrentChange"-->
<!--                :current-page="page.page"-->
<!--                :page-sizes="[10,20,30,100]"-->
<!--                :page-size="page.size"-->
<!--                layout="total, sizes, prev, pager, next"-->
<!--                :total="page.totalElements">-->
<!--            </el-pagination>-->
        </el-card>
    </div>

</template>

<script>
import settingMix from '@/utils/mix/common-setting'
import {downloadDataBook, orderSearch1} from "@/http/iosBookApi";
import DateUtil from "@/utils/DateUtil";

export default {
    name: "BookOrder1",
    mixins: [settingMix],
    data() {
        return {
            page: {
                size: 300,
                page: 1,
                totalElements: null
            },
            orderList: [],
            queryOrderData: {
                "userId": null,
                "createDt": null,
                "updateDt": null,
                "payDt": null,
                "status": null,
                "type": null,
                "ab": null,
                "sys": null,
                "name": null,
                "money": null,
                "page": 1,
                "size": 300
            }
        }
    },
    methods: {
        handleCurrentChange(page) {
            this.page.page = page;
            this.queryOrderData.page = page;
            this.searchOrder()
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.queryOrderData.size = size;
            this.searchOrder()
        },
        page1() {
            this.page.page = 1;
            this.queryOrderData.page = 1;
        },
        searchOrder() {
            this.queryOrderData.size = this.page.size;
            this.queryOrderData.page = this.page.page;
            if (this.queryOrderData.createDt != null) {
                this.queryOrderData.createDtStart = this.queryOrderData.createDt[0] === '' ? null : this.queryOrderData.createDt[0];
                this.queryOrderData.createDtEnd = this.queryOrderData.createDt[1] === '' ? null : this.queryOrderData.createDt[1];
            } else {
                this.queryOrderData.createDtStart = null;
                this.queryOrderData.createDtEnd = null;
            }
            if (this.queryOrderData.updateDt != null) {
                this.queryOrderData.updateDtStart = this.queryOrderData.updateDt[0] === '' ? null : this.queryOrderData.updateDt[0];
                this.queryOrderData.updateDtEnd = this.queryOrderData.updateDt[1] === '' ? null : this.queryOrderData.updateDt[1];
            } else {
                this.queryOrderData.updateDtStart = null;
                this.queryOrderData.updateDtEnd = null;
            }
            if (this.queryOrderData.payDt != null) {
                this.queryOrderData.payDtStart = this.queryOrderData.payDt[0] === '' ? null : this.queryOrderData.payDt[0];
                this.queryOrderData.payDtEnd = this.queryOrderData.payDt[1] === '' ? null : this.queryOrderData.payDt[1];
            } else {
                this.queryOrderData.payDtStart = null;
                this.queryOrderData.payDtEnd = null;
            }
            orderSearch1(this.queryOrderData).then(resp => {
                this.orderList = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
            })
        },
        exportExcel() {
            let fileName = new Date().toLocaleString() + '团团订单.xlsx';
            downloadDataBook(
                '/order/excel',
                Object.assign(this.queryOrderData),
                fileName
            )
        },
    },
    created() {
        this.queryOrderData.createDt = DateUtil.getIntervalDate(1);
        this.searchOrder();
    },
}
</script>

<style scoped>

</style>
